import React from 'react';
import { useObservability } from 'shared/helpers/observability';
import { ExternalLink } from 'platform/react-router';
import { Button } from '@opendoor/bricks/core';
import { NavLinkProps } from 'react-router-dom';

export interface INavLinkWithMetricsProps extends NavLinkProps {
  label: string;
  awayFromCake?: boolean;
  newTab?: boolean;
  onClick?: () => void;
}

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const NavLinkWithMetrics: React.FC<INavLinkWithMetricsProps> = ({
  awayFromCake,
  label,
  newTab,
  onClick,
  to,
  children,
}) => {
  const { trackUserEvent } = useObservability();

  const handleClick = () => {
    trackUserEvent({ linkClickEvent: { targetName: label } });
    onClick && onClick();
  };

  if (awayFromCake) {
    // NavHashLink doesn't change the domain of the url, so when we are navigating to
    // a completely new domain, we need to us a Brick's <ExternalLink> component
    // handle if opening a new tab.
    const newTabProps = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};

    return (
      <ExternalLink
        href={to.toString()}
        {...newTabProps}
        onClick={handleClick}
        analyticsName={`cake-${label}`}
        aria-label={null}
      >
        {children}
      </ExternalLink>
    );
  }

  return (
    <Button
      aria-label={null}
      analyticsName={`cake-${label}`}
      variant="link"
      fontWeight="normal"
      onClick={() => {
        const hash = to.toString().split('#')[1];
        const element = document.getElementById(hash);
        element && element.scrollIntoView();
        handleClick();
      }}
    >
      {children}
    </Button>
  );
};
